export class PaymentResponse {
  hmak?: string;
  payBoxLink?: string;
  mode?: string;
  site?: string;
  rang?: string;
  identifiant?: string;
  paymentDateTime?: string;
  numberOfScheduleLines?: number;
  singlePrice?: string;
  total?: string;
  product?: string;
}
